import { LoadingSkeleton } from 'sonata-react-components';

import { DefaultCreativeSkeletonStyled, ListItemSkeletonStyled } from './DCOSkeleton.styled';

function DCOSkeleton({ rows = 4 }: { rows?: number }) {
  return (
    <>
      <DefaultCreativeSkeletonStyled>
        <div className="defaultCreativeSkeleton__label">
          <LoadingSkeleton height={16} style={{ borderRadius: 4 }} width={400} />
        </div>
        <div className="defaultCreativeSkeleton__select">
          <LoadingSkeleton height={18} style={{ borderRadius: 8 }} width={220} />
        </div>
      </DefaultCreativeSkeletonStyled>
      {Array.from({ length: rows }).map((_, idx) => (
        <ListItemSkeletonStyled className="listItemSkeleton" key={idx}>
          <div className="DCOSkeleton__priority">
            <LoadingSkeleton height={18} style={{ borderRadius: 8 }} width={60} />
          </div>
          <div className="DCOSkeleton__context">
            <LoadingSkeleton height={16} style={{ borderRadius: 4 }} width={180} />
          </div>
          <div className="DCOSkeleton__wrapper">
            <LoadingSkeleton height={18} style={{ borderRadius: 8 }} width={180} />
          </div>
          <div className="DCOSkeleton__count">
            <LoadingSkeleton height={16} style={{ borderRadius: 8 }} width={24} />
          </div>
          <div className="DCOSkeleton__link">
            <LoadingSkeleton height={16} style={{ borderRadius: 8 }} width={70} />
          </div>
          <div className="DCOSkeleton__edit">
            <LoadingSkeleton height={24} width={24} />
          </div>
          <div className="DCOSkeleton__more">
            <LoadingSkeleton height={24} width={24} />
          </div>
        </ListItemSkeletonStyled>
      ))}
    </>
  );
}

export default DCOSkeleton;
